/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const conversionNodes = document.querySelectorAll('.conversion');
if (conversionNodes.length > 0) {
    import(/* webpackChunkName: "Conversion" */ './components/Conversion').then(({default: Conversion}) => {
        [...conversionNodes].forEach((node) => render(<Conversion {...parseDataToProps(node.dataset)} />, node));
    });
}
